import { UserRole } from "features/User/models";
import { newHireJourneyPathById, userPathById } from "helpers/url/pages/v1";
import { NewHireJourney } from "models/v2/newHireJourney";

export type ColorStyle =
  | {
      light: string;
      dark: string;
      lightHover: string;
      darkHover: string;
    }
  | Record<string, never>;

const newHireTagColors = {
  light: "var(--chakra-colors-newHireGreen-bg)",
  dark: "var(--chakra-colors-newHireGreen-text)",
  lightHover: "var(--chakra-colors-newHireGreen-bgHover)",
  darkHover: "var(--chakra-colors-newHireGreen-textHover)",
};
const managerTagColors = {
  light: "var(--chakra-colors-cdsIndigo-100)",
  dark: "var(--chakra-colors-cdsIndigo-800)",
  lightHover: "var(--chakra-colors-cdsIndigo-200)",
  darkHover: "var(--chakra-colors-cdsIndigo-700)",
};
const peopleTeamTagColors = {
  light: "var(--chakra-colors-peopleTeamBlue-light)",
  dark: "var(--chakra-colors-peopleTeamBlue-dark)",
  lightHover: "var(--chakra-colors-peopleTeamBlue-lightHover)",
  darkHover: "var(--chakra-colors-peopleTeamBlue-darkHover)",
};
const buddyTagColors = {
  light: "var(--chakra-colors-cdsOrange-50)",
  dark: "var(--chakra-colors-cdsOrange-600)",
  lightHover: "var(--chakra-colors-cdsOrange-100)",
  darkHover: "var(--chakra-colors-cdsOrange-500)",
};
const recruiterTagColors = {
  light: "var(--chakra-colors-cdsCyan-50)",
  dark: "var(--chakra-colors-cdsCyan-700)",
  lightHover: "var(--chakra-colors-cdsCyan-100)",
  darkHover: "var(--chakra-colors-cdsCyan-600)",
};
const itTeamTagColors = {
  light: "var(--chakra-colors-cdsGrey-100)",
  dark: "var(--chakra-colors-cdsGrey-800)",
  lightHover: "var(--chakra-colors-cdsGrey-200)",
  darkHover: "var(--chakra-colors-cdsGrey-700)",
};
const greyTagColors = {
  light: "var(--chakra-colors-darkModeHoverColor-DEFAULT)",
  dark: "var(--chakra-colors-cdsGrey-800)",
  lightHover: "var(--chakra-colors-darkModeHoverColor-200)",
  darkHover: "var(--chakra-colors-cdsGrey-700)",
};

export function roleStyles(roleName: UserRole | undefined): ColorStyle {
  switch (roleName) {
    case "new_hire":
      return newHireTagColors;
    case "manager":
      return managerTagColors;
    case "people_team_contact":
      return peopleTeamTagColors;
    case "buddy":
      return buddyTagColors;
    case "recruiter":
      return recruiterTagColors;
    case "it_team_contact":
      return itTeamTagColors;
    default:
      return greyTagColors;
  }
}

export function roleUrl(newHire: NewHireJourney, roleName: UserRole | undefined) {
  switch (roleName) {
    case "new_hire":
      return newHireJourneyPathById(newHire?.id);
    case "manager":
      return userPathById(newHire?.manager?.id);
    case "people_team_contact":
      return userPathById(newHire?.peopleTeamContactId);
    case "buddy":
      return userPathById(newHire?.buddyId);
    case "recruiter":
      return userPathById(newHire?.recruiterId);
    case "it_team_contact":
      return userPathById(newHire?.itTeamContactId);
    default:
      return "";
  }
}

export function roleUser(newHire: NewHireJourney, roleName: UserRole | undefined) {
  switch (roleName) {
    case "new_hire":
      return newHire?.newHire;
    case "manager":
      return newHire?.manager;
    case "people_team_contact":
      return newHire?.peopleTeamContact;
    case "buddy":
      return newHire?.buddy;
    case "recruiter":
      return newHire?.recruiter;
    case "it_team_contact":
      return newHire?.itTeamContact;
    default:
      return undefined;
  }
}
